import { fn_bridge_naver_login_exit } from "function/FnPosBridge";

interface NaverLoginConfig {
  clientId: string;
  redirectUri: string;
  scope?: string;
  state?: string;
}

export const useNaverLogin = (rootStore: any) => {
  const naverLogin = (config: NaverLoginConfig) => {
    fn_bridge_naver_login_exit(rootStore, "SHOW"); // 배달매니저 이동 버튼 호출

    const { clientId, redirectUri, scope = "email,name,nickname,profile_image" } = config;

    const naverAuthUrl = `https://nid.naver.com/oauth2.0/authorize?response_type=code&client_id=${clientId}&redirect_uri=${encodeURIComponent(
      redirectUri
    )}&state=${encodeURIComponent("naver_login")}&scope=${scope}`;

    window.location.href = naverAuthUrl;
  };

  const naverLogout = (config: NaverLoginConfig) => {
	const { clientId, redirectUri } = config;

    const naverLogoutUrl = `https://nid.naver.com/oauth2.0/logout?client_id=${clientId}&redirect_uri=${encodeURIComponent(
		redirectUri
	  )}&state=logout`;

	  window.location.href = naverLogoutUrl;
  }

  return {
    naverLogin,
    naverLogout,
  };
};
